import React, { useContext, useState } from "react";
import { useMessageSource } from "react-message-source";
import { ProductContext } from "../../../context/product-context/productContext";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CustomTypography from "../../../ui/widgets/typography";
import { BootstrapperContext } from "../../../context/bootstrapperContext";
import { Product } from "../../../context/product-context/product";
import Dialog from "../../../ui/widgets/dialog";
import { ProductFamilySelectionContent } from "./product-family-selection-content";

interface ProductFamilySelectionProps {
  handleOnProductFamilySelection: (product: Product) => void;
}

const ProductFamilySelectionModal: React.FC<ProductFamilySelectionProps> = ({
  handleOnProductFamilySelection,
}: ProductFamilySelectionProps) => {
  const { getMessage } = useMessageSource();
  const { selectedProduct, resetProductToDefault } = useContext(ProductContext);
  const { families } = useContext(BootstrapperContext);
  const [open, setOpen] = useState<boolean>(!selectedProduct);

  const handleDialogClose = (): void => setOpen(false);

  resetProductToDefault();

  return (
    families.length !== 1 && (
      <Dialog disableEscapeKeyDown open={open}>
        <TypographyItemContainer>
          <CustomTypography variant="h2">
            {getMessage("ProductFamily.title")}
          </CustomTypography>
        </TypographyItemContainer>
        <ProductFamilySelectionContent
          families={families}
          handleDialogClose={handleDialogClose}
          handleOnProductFamilySelection={handleOnProductFamilySelection}
        />
      </Dialog>
    )
  );
};

export default ProductFamilySelectionModal;
